import { cn } from '@kar-dmp/ignite';

export const TwoColumn = ({ children, className, ...props }) => (
	<div
		{...props}
		className={cn(
			'relative z-[3] flex h-auto min-h-dvh w-dvw flex-col items-stretch justify-stretch overflow-hidden',
			'md:h-dvh! md:min-h-0! md:flex-row! 2xl:justify-start!',
			className,
		)}
	>
		{children}
	</div>
);

export const Card = ({ children, className, noCardPadding, ...props }) => (
	<div
		{...props}
		className={cn(
			'absolute left-0 flex h-auto min-h-full w-full max-w-full flex-1 basis-full items-center justify-center rounded-none bg-white shadow-md',
			noCardPadding ? 'p-0!' : 'px-6 py-10 md:px-10! md:py-[60px]!',
			'lg:w-[35%]! lg:max-w-[35%]! lg:flex-[0_0_35%]! lg:basis-[35%]!',
			'2xl:w-[calc(100%-1200px)]! 2xl:max-w-full! 2xl:flex-auto!',
			className,
		)}
	>
		{children}
	</div>
);

export const SecondColumn = ({ children, className, ...props }) => (
	<div
		{...props}
		className={cn(
			'fixed right-0 hidden h-full w-[65%] flex-[0_0_65%] overflow-hidden',
			'lg:flex! 2xl:ml-auto! 2xl:w-[1200px]! 2xl:max-w-[1200px]! 2xl:flex-[0_0_1200px]!',
			className,
		)}
	>
		{children}
	</div>
);
